/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { Metadata, SendEventData } from '../types'

export class EventSenderPlugin {
  name: string

  constructor(name: string) {
    this.name = name
  }

  init() {}

  sendEvent(event: SendEventData) {}

  updateUserMetadata(metadata: Metadata) {}
}
